import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Loader2, X } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

// Historique des acceptations CGU d'un utilisateur (fiche utilisateur admin).
export default function CguUserHistoryDialog({ userId, onClose }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { api.get(`/admin/cgu/users/${userId}`).then(({ data: d }) => setData(d)).catch((e) => setErr(formatApiError(e))); }, [userId]);

  return createPortal(
    <div className="fixed inset-0 z-[96] flex items-center justify-center bg-black/60 p-4" data-testid="cgu-user-history-dialog" onClick={onClose}>
      <div className="max-h-[85vh] w-full max-w-lg overflow-y-auto rounded-3xl bg-[#FFF8F1] p-5 street-border" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-2">
          <div className="font-[Outfit] text-[18px] font-black">Historique CGU{data ? ` · ${data.user.email}` : ""}</div>
          <button type="button" onClick={onClose} aria-label="Fermer" data-testid="cgu-user-history-close"><X className="h-5 w-5" /></button>
        </div>
        {err && <p className="mt-3 text-sm font-bold text-red-700">{err}</p>}
        {!data && !err && <Loader2 className="mt-4 h-5 w-5 animate-spin" />}
        {data && (
          <>
            <div className={`mt-3 rounded-xl px-3 py-2 text-[12px] font-black ${data.required ? "bg-red-100 text-red-900" : "bg-emerald-100 text-emerald-900"}`} data-testid="cgu-user-history-status">
              {data.required ? "N'a pas encore accepté la version exigée" : "À jour"}
            </div>
            <div className="mt-3 space-y-1.5">
              {data.items.length === 0 && <p className="text-[13px] font-semibold">Aucune acceptation enregistrée.</p>}
              {data.items.map((a) => (
                <div key={a.id} className="rounded-xl bg-white px-3 py-2 text-[12px] street-border-thin" data-testid={`cgu-user-history-${a.id}`}>
                  <div className="font-black">Version {a.version} · {a.method === "signup" ? "à l'inscription" : "mise à jour"}</div>
                  <div className="font-semibold text-foreground/60">{new Date(a.accepted_at).toLocaleString("fr-FR")} · IP {a.ip || "—"}</div>
                  <div className="truncate font-mono text-[10px] text-foreground/40" title={a.content_hash}>Empreinte du texte : {a.content_hash}</div>
                </div>
              ))}
              {data.refusals.map((r) => (
                <div key={r.id} className="rounded-xl bg-red-50 px-3 py-2 text-[12px] font-semibold street-border-thin">Refus de la version {r.version} · {new Date(r.at).toLocaleString("fr-FR")}</div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>,
    document.body,
  );
}
